import { fork, take } from 'redux-saga/effects';

export function takeEveryFromBus(bus, patternOrChannel, saga, ...args) {
  return fork(function* () {
    while (true) {
      const action = yield take(bus, patternOrChannel);
      yield fork(saga, ...args.concat(action));
    }
  });
}
